'use strict';

exports.__esModule = true;
exports.default = array;
function array(length, value) {
    var arr = [];
    for (var i = 0; i < length; i++) {
        var val = typeof value !== 'undefined' ? value : i;
        arr.push(val);
    }
    return arr;
}


//////////////////
// WEBPACK FOOTER
// ./~/usfl/array/array.js
// module id = 545
// module chunks = 104101334113578